import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import styled from "styled-components";
import AuthenticationService from "../Login/Service/Authentication";
import { ROUTES } from "../../commons/constants/routes/routes";
import { withTranslation } from "react-i18next";

class Header extends Component {
  render() {
    const isUserLoggedIn = AuthenticationService.isUserLoggedIn();

    const pathname = window.location.pathname;
    // console.log(pathname.startsWith("/plant-list") ? "일치" : "불일치");
    const { t } = this.props;

    const isGuestPage =
      pathname === ROUTES.SIGNUP || pathname === ROUTES.FIND_ACCOUNT;

    return (
      <header id="header">
        <div className="container">
          {!isUserLoggedIn && isGuestPage && (
            <Logo>
              <Link to={ROUTES.LOGIN}>
                <img src="/images/ctors/frame/head/logo_naxa.svg" alt="NEXA" />
              </Link>
            </Logo>
          )}
          {isUserLoggedIn && (
            <>
              <Logo>
                <Link to="/">
                  <img src="/images/ctors/frame/head/logo_naxa.svg" alt="NEXA" />
                </Link>
              </Logo>
              <nav className="gnb">
                <NavLink to={ROUTES.DR} activeClassName="active">
                  +DR
                </NavLink>
                {/* 
                <NavLink to="/plant-status/main" activeClassName="active">
                  발전소 현황
                </NavLink> 
                */}
                <NavLink
                  to={ROUTES.PROJECT.MAIN}
                  className={
                    pathname.startsWith(ROUTES.PROJECT.BASE) ||
                    pathname.startsWith(ROUTES.PLANT_LIST().BASE)
                      ? "active"
                      : ""
                  }
                >
                  {t("key1")}
                </NavLink>
                <NavLink
                  to={ROUTES.MEMBER.MAIN}
                  className={pathname.startsWith(ROUTES.MEMBER.BASE) ? "active" : ""}
                >
                  회원관리
                </NavLink>
                <CsDropdown className={pathname.startsWith("/cs/") ? "cs-active" : ""}>
                  <Link
                    to={ROUTES.CS_INQUIRY.MAIN}
                    className={pathname.startsWith("/cs/") ? "active" : ""}
                  >
                    CS
                  </Link>
                  <ul className="cs-dropdown-menu">
                    <li>
                      <NavLink to={ROUTES.CS_INQUIRY.MAIN} activeClassName="active">
                        문의관리
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to={ROUTES.NOTICE.MAIN} activeClassName="active">
                        공지사항
                      </NavLink>
                    </li>
                  </ul>
                </CsDropdown>
                <NavLink to={ROUTES.MYPAGE}>{t("key2")}</NavLink>
                <Link to={ROUTES.LOGOUT} onClick={AuthenticationService.logout}>
                  {t("key3")}
                </Link>
              </nav>
            </>
          )}
        </div>
      </header>
    );
  }
}

const Logo = styled.div`
  img {
    height: 24px;
    width: auto;
  }
`;

const CsDropdown = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  .cs-dropdown-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
    min-width: 110px;
    z-index: 200;
    list-style: none;
    padding: 6px 0;
    margin: 0;
    overflow: hidden;

    li {
      border-bottom: 1px solid #f0f2f5;
      &:last-child {
        border-bottom: none;
      }
    }

    li a {
      display: block !important;
      padding: 9px 16px !important;
      color: #333 !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      line-height: 1.4 !important;
      text-decoration: none !important;
      white-space: nowrap !important;
      border-radius: 0 !important;
      margin-right: 0 !important;
      background: transparent !important;
      transition: background 0.15s, color 0.15s !important;

      &:hover {
        background: #f4f6fb !important;
        color: var(--secondary-500) !important;
      }

      &.active {
        color: var(--secondary-500) !important;
        font-weight: 700 !important;
        background: #eef0f7 !important;
        border-left: 3px solid var(--secondary-500);
        padding-left: 13px !important;
      }
    }
  }

  &:hover .cs-dropdown-menu {
    display: block;
  }
`;

export default withTranslation()(Header);
